exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".seo-tooltip-footer h1{font-size:26px;margin:0}\n", ""]);

// exports
